import React from 'react'
import ReactDOM from 'react-dom'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './styles/main.scss'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))